import { Checkbox, Text } from '..';

interface ICheckboxItemProps {
  label: string;
  image?: string; //추후 삭제하고 모든 image prop을 imageComponent로 교체할 것
  imageComponent?: React.ReactNode;
  imageSize?: number; //imageSize가 32일 시 체크박스-이미지-라벨이 일렬로 나열
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
}

export const CheckboxItem = (props: ICheckboxItemProps) => {
  const { label, image, imageComponent, imageSize = 100, isChecked, onChange } = props;

  return (
    <>
      {image || imageComponent ? (
        <div
          onClick={() => {
            onChange(isChecked);
          }}
          style={{ cursor: 'pointer', width: 100 }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Checkbox
              checked={isChecked}
              sx={{
                width: 20,
                height: 20,
                marginLeft: 0
              }}
            />
            {imageSize === 32 && imageComponent ? <div style={{ marginRight: '8px' }}>{imageComponent}</div> : null}
            <Text variant="body1">{label}</Text>
          </div>
          {imageSize === 32 ? null : (
            <img src={image} style={{ width: imageSize, height: imageSize, marginTop: '6px' }} />
          )}
        </div>
      ) : (
        <div
          onClick={() => {
            onChange(isChecked);
          }}
          style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }}
        >
          <Checkbox
            checked={isChecked}
            onClick={() => {
              onChange(isChecked);
            }}
            sx={{
              width: 20,
              height: 20,
              marginLeft: 0
            }}
          />
          <Text variant="body1">{label}</Text>
        </div>
      )}
    </>
  );
};
